import Properties from "./Properties";
import Theme from "./Theme";
import Wrapper from "./Wrapper";
import Placeholder from "./Placeholder";
import Integrations from "./Integrations";
import Email from "./Email";
import Ingestion from "./Ingestion";
import Subjects from "./subjects";
import Content from "./Content";

export default {
  Properties,
  Wrapper,
  Theme,
  Placeholder,
  Integrations,
  Email,
  Ingestion,
  Subjects,
  Content
};
